// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"4b30662e","152":"c908fee4","366":"f239044b"}[chunkId] + ".chunk.css";
};